import ContentLoader from 'react-content-loader';

import { varMappings } from '@/utils/generated/varMappings';

export const ScoreContentLoader = () => (
  <ContentLoader
    className="rounded-[6px] my-2"
    width="18"
    height="16"
    foregroundColor={varMappings['token-gray-400']}
    backgroundColor={varMappings['token-gray-200']}
    uniqueKey="securityAuditLoader"
  >
    <rect x="0" y="0" height="100%" width="100%" />
  </ContentLoader>
);
